import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import {environment} from "../../environments/environment";

@Injectable({ providedIn: 'root' })
export class EntradaService {


    backendUrl: string = environment.apiUrl;
    url_final: string;

    constructor(private http: HttpClient) {
    }

    actualizarEntrada(entrada_token, num_guia, paqueteria) {
      this.url_final = this.backendUrl + "/rmsfe/guardar_guia_entrada"
      this.url_final =
        `${this.url_final}?entrada_token=${entrada_token}&paqueteria=${paqueteria}&num_guia=${num_guia}`;
      return this.http.get<any>(this.url_final, {observe: 'response'})
      .pipe(map(response => {
        // console.log("la api es");
        // console.log(response)
        return response;
      }));
    }

    enviarEntrada(entries, num_guia, paqueteria, seller, apoyo, arrival_date, arrival_time_start, arrival_time_end){
      this.url_final = this.backendUrl + "/rmsfe/nueva_entrada"
      this.url_final = `${this.url_final}`;
      return this.http.post<any>(this.url_final, { entries, num_guia, paqueteria, seller, apoyo, arrival_date, arrival_time_start, arrival_time_end})
      .pipe(map(response => {
        // console.log("la api es");
        // console.log(response)
        return response;
      }));
    }

    consultarInboundSettings(){
      this.url_final = this.backendUrl + "/rmsfe/inbound_settings"
      this.url_final = `${this.url_final}`;
      return this.http.get<any>(this.url_final, {observe: 'response'})
      .pipe(map(response => {
        return response;
      }));
    }

    consultarEntrada(entrada_token){
      this.url_final = this.backendUrl + "/rmsfe/entrada_show"
      this.url_final =
        `${this.url_final}?entrada_token=${entrada_token}`;
      return this.http.get<any>(this.url_final, {observe: 'response'})
      .pipe(map(response => {
        // console.log("la api es");
        // console.log(response)
        return response;
      }));
    }

    consultarErrores(entrada_token){
      this.url_final = this.backendUrl + "/rmsfe/errores_entrada"
      this.url_final =
        `${this.url_final}?entrada_token=${entrada_token}`;
      return this.http.get<any>(this.url_final, {observe: 'response'})
      .pipe(map(response => {
        return response;
      }));
    }


    generarEtiqueta(entrada_token){
      this.url_final = this.backendUrl + "/rmsfe/generar_etiquetas_api"
      this.url_final = `${this.url_final}`;
      return this.http.post<any>(this.url_final, { entrada_token})
      .pipe(map(response => {
        // console.log("la api es");
        // console.log(response)
        return response;
      }));
    }

    consultarEtiquetas(entrada_token){
      this.url_final = this.backendUrl + "/rmsfe/consultar_etiquetas"
      this.url_final = `${this.url_final}?entrada_token=${entrada_token}`;
      return this.http.get<any>(this.url_final, { observe: 'response'})
      .pipe(map(response => {
        // console.log("la api es");
        // console.log(response)
        return response;
      }));
    }

    generarPlantilla(){
      this.url_final = this.backendUrl + "/rmsfe/generar_plantilla_api"
      this.url_final = `${this.url_final}`;
      return this.http.post<any>(this.url_final, { })
      .pipe(map(response => {
        // console.log("la api es");
        // console.log(response)
        return response;
      }));
    }

    consultarPlantilla(){
      this.url_final = this.backendUrl + "/rmsfe/consultar_plantilla"
      this.url_final = `${this.url_final}`;
      return this.http.get<any>(this.url_final, { observe: 'response'})
      .pipe(map(response => {
        // console.log("la api es");
        // console.log(response)
        return response;
      }));
    }

    mandarEntrada(file_name, arrival_date?: string, arrival_time_start?: string, arrival_time_end?: string){
      this.url_final = this.backendUrl + "/rmsfe/entrada_masiva_api"
      this.url_final = `${this.url_final}`;
      return this.http.post<any>(this.url_final, { file_name, arrival_date, arrival_time_start, arrival_time_end })
      .pipe(map(response => {
        return response;
      }));
    }

    consultarMasivo(){
      this.url_final = this.backendUrl + "/rmsfe/consultar_masivo"
      this.url_final = `${this.url_final}`;
      return this.http.get<any>(this.url_final, { observe: 'response'})
      .pipe(map(response => {
        // console.log("la api es");
        // console.log(response)
        return response;
      }));
    }

    mandarApoyoEntrada(entrada_token){
      this.url_final = this.backendUrl + "/rmsfe/set_solicitar_apoyo"
      this.url_final = `${this.url_final}`;
      return this.http.post<any>(this.url_final, { entrada_token })
      .pipe(map(response => {
        // console.log("la api es");
        // console.log(response)
        return response;
      }));
    }

    consultarInboundEvents(entrada_token){
      this.url_final = this.backendUrl + "/rmsfe/inbound_events"
      this.url_final = `${this.url_final}?entrada_token=${entrada_token}`;
      return this.http.get<any>(this.url_final, {observe: 'response'})
      .pipe(map(response => {
        return response;
      }));
    }

    validarFechaLlegada(fecha: string){
      this.url_final = this.backendUrl + "/rmsfe/validar_fecha_llegada"
      this.url_final = `${this.url_final}?fecha=${fecha}`;
      return this.http.get<any>(this.url_final, {observe: 'response'})
      .pipe(map(response => {
        return response;
      }));
    }

    obtenerSlotsDisponibles(fecha: string, entrada_token?: string){
      this.url_final = this.backendUrl + "/rmsfe/obtener_slots_disponibles"
      this.url_final = `${this.url_final}?fecha=${fecha}`;
      
      // Agregar entrada_token si se está editando (para excluir del conteo)
      if (entrada_token) {
        this.url_final += `&entrada_token=${entrada_token}`;
      }
      
      return this.http.get<any>(this.url_final, {observe: 'response'})
      .pipe(map(response => {
        return response;
      }));
    }

    // Nuevos métodos para edición de entradas
    validarEntradaEditable(entrada_token: string){
      this.url_final = this.backendUrl + "/rmsfe/validar_entrada_editable";
      this.url_final = `${this.url_final}?entrada_token=${entrada_token}`;
      return this.http.get<any>(this.url_final, {observe: 'response'})
      .pipe(map(response => {
        return response;
      }));
    }

    actualizarProductosEntrada(entrada_token: string, productos: any[]){
      this.url_final = this.backendUrl + "/rmsfe/actualizar_productos_entrada";
      return this.http.put<any>(this.url_final, { entrada_token, productos }, {observe: 'response'})
      .pipe(map(response => {
        return response;
      }));
    }

    actualizarFechaHoraEntrada(entrada_token: string, arrival_date: string, 
                              arrival_time_start: string, arrival_time_end: string){
      this.url_final = this.backendUrl + "/rmsfe/actualizar_fecha_hora_entrada";
      return this.http.put<any>(this.url_final, { 
        entrada_token, 
        arrival_date, 
        arrival_time_start, 
        arrival_time_end 
      }, {observe: 'response'})
      .pipe(map(response => {
        return response;
      }));
    }

    cancelarEntrada(entrada_token: string, comentario_cancelacion: string){
      this.url_final = this.backendUrl + "/rmsfe/cancelar_entrada";
      return this.http.put<any>(this.url_final, {
        entrada_token,
        comentario_cancelacion
      }, {observe: 'response'})
      .pipe(map(response => {
        return response;
      }));
    }

}